import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject, Injector, runInInjectionContext } from '@angular/core';
import { AppInitializationService } from '@core/app-initialization/app-initialization.service';
import { AppUpdater } from '@shared/appUpdater.service';
import { ShellContextService } from '../../services/shell-context/shell-context.service';
import { LogoutService } from '../../services/authentication/logout.service';
import { CompanyType } from '@nodeModules/@itero/auth-angular';
import { TimberService } from '@logging/timber.service';

const redirectToPlatformLoginPage = (): false => {
	const logoutService = inject(LogoutService);

	inject(AppUpdater).checkForUpdates();
	inject(ShellContextService).resetContext();

	return logoutService.logoutWithoutSessionInvalidation();
};

export const appInitializationGuard: CanActivateChildFn | CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const service = inject(AppInitializationService);
	const cookie = service.allInitializationCookie;

	const hasMissingCookies = cookie.missing.length > 0;
	const isNotALab = (cookie.businessCookie.companyType as CompanyType) !== CompanyType.Lab;

	if (hasMissingCookies || isNotALab) {
		inject(TimberService).error(`Missing cookie. Missing: ${JSON.stringify(cookie.missing)}`, { module: 'AppInitializationGuard' });

		return runInInjectionContext(inject(Injector), () => {
			return redirectToPlatformLoginPage();
		});
	}

	return service.init(cookie);
};
